jQuery(function($) {

  $('.rankingSlider').slick({
    autoplay: false,
    infinite: false,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [{
      breakpoint: 1281,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    }, {
      breakpoint: 835,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    }, {
      breakpoint: 651,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }]
  });

  var isTouch = ('ontouchstart' in window);
  $(document).on('click', '.grid-product__link', function() {
    return false;
  });
  $('.slick-track').bind({
    'touchstart mousedown': function(e) {
      var props2 = $('.slick-track').css('transform');
      var values = props2.split('(')[1];
      values = values.split(')')[0];
      values = values.split(', ');
      this.pageX = (isTouch ? event.changedTouches[0].pageX : e.pageX);
      basePoint = values[4];
      this.touched = true;
      console.log();
    },
    'touchmove mousemove': function(e) {
      var props2 = $('.slick-track').css('transform');
      var values = props2.split('(')[1];
      values = values.split(')')[0];
      values = values.split(', ');
      this.pageX = (isTouch ? event.changedTouches[0].pageX : e.pageX);
      this.left = values[4];
      this.touched = true;
    },
    'touchend mouseup': function(e) {
      if(Math.abs(this.left - basePoint) < -5) {
        var goUrl = $(e.target).closest('a').attr('href');
        if(goUrl != undefined) {
          window.location.href = goUrl;
        }

      }
    }
  });

});